import styled from 'styled-components';
import Image from 'next/image';
import { Image as ImageType } from 'data/types';

type ProductImagesProps = {
  images: ImageType[];
};

const ProductImages: React.FC<ProductImagesProps> = ({ images }) => (
  <StyledProductImages>
    {images.map((image) => (
      <div key={image._id} className="image-wrapper">
        <Image
          src={image.src}
          width={image.width}
          height={image.height}
          layout="responsive"
          alt={image.alt || image.title || ''}
        />
        <div className="image-overlay" />
      </div>
    ))}
  </StyledProductImages>
);

const StyledProductImages = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .image-wrapper {
    margin: 0 0 1rem 0;
    width: 100%;
    position: relative;
  }
`;

export default ProductImages;
